import { teamMemberType } from "../../components/Models/teamDataType";

export const sbhTeam: teamMemberType[] = [
  
  {
    "name": "Dr. Pampa Debnath",
    "designation": "Coordinator",
    "committee": "Technical Program Design",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Abhishek Basu",
    "designation": "SBH Jr.",
    "committee": "Technical Program Design",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Rajib Saha",
    "designation": "SBH Jr.",
    "committee": "Technical Program Design",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Arijit Ghosh",
    "designation": "",
    "committee": "Technical Program Design",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Soumyadip Dhar",
    "designation": "",
    "committee": "Technical Program Design",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Arpita Ghosh",
    "designation": "",
    "committee": "Technical Program Design",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Ranjan Jana",
    "designation": "",
    "committee": "Technical Program Design",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Budhaditya Biswas",
    "designation": "",
    "committee": "Technical Program Design",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Sujoy Mondal",
    "designation": "",
    "committee": "Technical Program Design",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Anirban Dey",
    "designation": "",
    "committee": "Technical Program Design",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Swapan Shakhari",
    "designation": "",
    "committee": "Technical Program Design",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Manas Ghosh",
    "designation": "FIC T&P (Coordinator)",
    "committee": "Corporate Collaboration & Sponsorship",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Rajib Saha",
    "designation": "",
    "committee": "Corporate Collaboration & Sponsorship",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Somenath Nag Chowdhury",
    "designation": "",
    "committee": "Corporate Collaboration & Sponsorship",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Srijan Bhattacharya",
    "designation": "",
    "committee": "Corporate Collaboration & Sponsorship",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Avijit Saha",
    "designation": "Coordinator",
    "committee": "Infrastructure and Logistics",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Srijan Bhattacharya",
    "designation": "SBH Jr.",
    "committee": "Infrastructure and Logistics",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Sarbojit Mukherjee",
    "designation": "SBH Jr.",
    "committee": "Infrastructure and Logistics",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Jayanta Datta",
    "designation": "",
    "committee": "Infrastructure and Logistics",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Sandip Saha",
    "designation": "Registrar",
    "committee": "Infrastructure and Logistics",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Pradip Kumar Das",
    "designation": "Registrar",
    "committee": "Infrastructure and Logistics",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Arijit Majumdar",
    "designation": "Asst. System Admin.",
    "committee": "Infrastructure and Logistics",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Dipankar Santra",
    "designation": "",
    "committee": "Infrastructure and Logistics",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Utpal Dastidar",
    "designation": "Jr. Asst.",
    "committee": "Infrastructure and Logistics",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Souvik Majumdar",
    "designation": "",
    "committee": "Infrastructure and Logistics",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mrs. Monika Singh",
    "designation": "",
    "committee": "Infrastructure and Logistics",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Soumen Mukherjee",
    "designation": "Coordinator",
    "committee": "Finance",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Prof. (Dr.) Indrajit Pan",
    "designation": "",
    "committee": "Finance",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Arpan Deyasi",
    "designation": "",
    "committee": "Finance",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Abhishek Basu",
    "designation": "",
    "committee": "Finance",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Chinmoy Ghoshal",
    "designation": "Finance Officer",
    "committee": "Finance",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Naiwrita Dey",
    "designation": "Coordinator",
    "committee": "Technical Event Coordination",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Srijan Bhattacharya",
    "designation": "SBH Jr.",
    "committee": "Technical Event Coordination",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Falguni Adhikary",
    "designation": "SBH Jr.",
    "committee": "Technical Event Coordination",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Subhasis Bandopadhyay",
    "designation": "",
    "committee": "Technical Event Coordination",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Subhrajit Sinharoy",
    "designation": "",
    "committee": "Technical Event Coordination",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Srirupa Das",
    "designation": "",
    "committee": "Technical Event Coordination",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Avishek Paul",
    "designation": "",
    "committee": "Technical Event Coordination",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Dipankar Majumdar",
    "designation": "",
    "committee": "Technical Event Coordination",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Avishek Bal",
    "designation": "",
    "committee": "Technical Event Coordination",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Arup Kumar Bhattacharjee",
    "designation": "",
    "committee": "Technical Event Coordination",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Nandan Bhattacharya",
    "designation": "",
    "committee": "Technical Event Coordination",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Subhasis Chowdhury",
    "designation": "",
    "committee": "Technical Event Coordination",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mrs. Sharbari Kundu",
    "designation": "Coordinator",
    "committee": "Invitation, Publication & Media",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Dipan Bandyopadhyay",
    "designation": "",
    "committee": "Invitation, Publication & Media",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Palash Kumar Ghosh",
    "designation": "",
    "committee": "Invitation, Publication & Media",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Lidia Ghosh",
    "designation": "",
    "committee": "Invitation, Publication & Media",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mrs. Moumita Banerjee",
    "designation": "",
    "committee": "Invitation, Publication & Media",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Swarup Kumar Paul",
    "designation": "",
    "committee": "Invitation, Publication & Media",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Satarupa Chatterjee",
    "designation": "",
    "committee": "Invitation, Publication & Media",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Ms. Sohini Sen",
    "designation": "",
    "committee": "Invitation, Publication & Media",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mrs. Sohini Paul",
    "designation": "",
    "committee": "Invitation, Publication & Media",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mrs. Sulagna Basak",
    "designation": "",
    "committee": "Invitation, Publication & Media",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Soumen Mukherjee",
    "designation": "Coordinator",
    "committee": "Website",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Dr. Abhishek Basu",
    "designation": "",
    "committee": "Website",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Anirban Dey",
    "designation": "",
    "committee": "Website",
    "img": "https://example.com/dummy.jpg"
  },
  {
    "name": "Mr. Souvik Majumdar",
    "designation": "",
    "committee": "Website",
    "img": "https://example.com/dummy.jpg"
  },
];
